import { CommonModule } from '@angular/common';
import { Component, ViewChild, computed, signal } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from 'src/app/common.module';
import { Site } from 'src/app/models/site.model';
import { RoomTicket } from 'src/app/models/ticket.model';
import { TranslateTicketPipe } from 'src/app/pipes/ticket-translate/ticket-translate.pipe';
import { WorkerTicketsService } from 'src/app/services/worker-tickets.service';
import { storageKeys } from 'src/app/utility/constants';
import { MainDialogComponent } from '../../main-dialog/main-dialog.component';
import { SegmentListComponent } from '../../segment-list/segment-list.component';
import { AiTasksComponent } from '../ai/ai.component';
import { NewAdhocComponent } from '../new/new-adhoc.component';

@Component({
  selector: 'app-new-adhoc-dialog',
  templateUrl: './new-adhoc.dialog.html',
  styleUrls: ['./new-adhoc.dialog.scss'],
  providers: [TranslateTicketPipe],
  imports: [
    AppCommonModule,
    CommonModule, MainDialogComponent,
    NewAdhocComponent,
    AiTasksComponent,
    SegmentListComponent,
  ],
})
export class NewAdhocDialogComponent {

  @ViewChild(AiTasksComponent)
  aiTasks: AiTasksComponent;

  ticketS = signal<RoomTicket>(null);
  siteS = signal<Site>(null);
  sitesS = signal<Site[]>(null);

  loaded = signal(false);
  innerBackS = signal(false);

  segment = signal('ai');

  segmentButtons = computed(() => [
    {
      value: 'ai',
      name: 'AI',
      icon: 'color-wand-outline',
      show: true,
    },
    {
      value: 'ticket',
      name: this.translate.instant('tickets.task'),
      show: true,
    },
  ]);

  constructor(
    private _modal: ModalController,
    private storageService: StorageService,
    private translate: TranslateService,
    private workerTicketsService: WorkerTicketsService,
    navParams: NavParams,
  ) {
    const ticket = navParams.get<RoomTicket>('ticket');
    const site = navParams.get<Site>('site');
    const sites = navParams.get<Site[]>('sites');

    this.ticketS.set(ticket);
    this.siteS.set(site);
    this.sitesS.set(sites);

    this.loaded.set(true);
  }

  saved(item?: RoomTicket | RoomTicket[]) {
    this.workerTicketsService.saveRoomTickets(item, null, true);
  }

  setHasInner(value: boolean) {
    this.innerBackS.set(value);
  }

  dismiss(item?: RoomTicket | RoomTicket[]) {
    if (this.innerBackS()) {
      this.aiTasks.emptySelectedTicket();
    } else {
      this.storageService.removeItem(storageKeys.newAdhoc);
      this._modal.dismiss(item);
    }
  }
}
